import { OnboardingTitle as BaseOnboardingTitle } from 'registration/containers/Onboarding';

import { withStyle } from 'shared/components/ihcl/styled';

export const OnboardingTitle = withStyle(BaseOnboardingTitle, {
  marginBottom: '32px',
});
